import script from "./ProjectTimesheets.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectTimesheets.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectTimesheets.vue?vue&type=style&index=0&id=8b5a8f94&lang=css"

const __exports__ = script;

export default __exports__